import React, { useState } from 'react'
import { Icon, Map as LeafletMap, Marker, Polyline, Popup, TileLayer } from 'react-leaflet';
import Menu from "@material-ui/core/Menu/Menu";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import { Context } from "./ContextProvider"
import { decodePolyline } from "./util/Geo";
import L from 'leaflet';
import * as Helpers from "./Helpers"
import TableCell from "@material-ui/core/TableCell/TableCell";
import ReactDOMServer from 'react-dom/server';
import { useTranslation } from "react-i18next";
import * as Logger from "./Logger";

export const aIcon = new L.Icon({
    iconUrl: './img/alpha-a-circle.svg',
    iconAnchor: [18, 18],
    iconSize: [30, 30],
});

export const bIcon = new L.Icon({
    iconUrl: './img/alpha-b-circle.svg',
    iconAnchor: [18, 18],
    iconSize: [30, 30],
});

export const circleIcon = new L.Icon({
    iconUrl: './img/circle.svg',
    iconAnchor: [18, 18],
    iconSize: [30, 30],
});

export const electricChargerIconSmall = new L.Icon({
    iconUrl: './img/modes/STATION.svg',
    iconAnchor: [18, 18],
    iconSize: [30, 30],
});

export const electricChargerIconBig = new L.Icon({
    iconUrl: './img/modes/STATION.svg',
    iconAnchor: [18, 18],
    iconSize: [45, 45],
});

function Map() {
    let { state, dispatch } = React.useContext(Context);

    const { t, i18n } = useTranslation();

    const [context, setContext] = useState({ visible: false });
    const { selectedItineraryId, selectedLegIndex, selectedStepIndex, itineraries } = state;
    Logger.log("map selecte iti id is: " + selectedItineraryId)

    function findIti(iti) {
        return iti.id === selectedItineraryId
    }

    function setStart(latlng) {
        dispatch({ type: "setStartOnMap", payload: latlng, });
        Helpers.coordinates2addressQuery(latlng, function (result) {
            dispatch({ type: "setStartDisplayName", payload: Helpers.toDisplayAddress(result) });
        })
    }

    function setEnd(latlng) {
        dispatch({ type: "setEndOnMap", payload: latlng });
        Helpers.coordinates2addressQuery(latlng, function (result) {
            dispatch({ type: "setEndDisplayName", payload: Helpers.toDisplayAddress(result) })
        })
    }


    function handleLeftClick(mouseEvent) {
        const where = mouseEvent.latlng;
        const from = state.startPosition;
        const to = state.endPosition;

        if (!from) {
            //setFrom(where);
            setStart(where);
        } else if (!to) {
            setEnd(where);
        } else {
            Logger.log("both from and to set, doing nothing")
        }
    }

    function handleContextMenuClick(mouseEvent) {

        setContext({
            visible: true,
            menuPosition:
            {
                top: mouseEvent.originalEvent.clientY,
                left:
                    mouseEvent.originalEvent.clientX,
            }
            ,
            latlng: mouseEvent.latlng,
        }
        )
    }

    function getFrom() {

        if (state.startPosition) {
            return <Marker
                icon={aIcon}
                draggable={true}
                descr={"Start"}
                position={state.startPosition}
                onDragend={event => setStart(event.target.getLatLng())}>
                <Popup>
                    Start
                </Popup>
            </Marker>
        }
    }

    function getTo() {
        if (state.endPosition) {
            return <Marker
                icon={bIcon}
                draggable={true}
                descr={"End"}
                position={state.endPosition}
                onDragend={event => setEnd(event.target.getLatLng())}>
                <Popup>
                    End
                </Popup>
            </Marker>
        }
    }

    // context menu support
    function setStartContext() {
        setStart(context.latlng);
        closeContext();
    }


    function closeContext() {
        setContext({})
    }

    function setEndContext() {
        setEnd(context.latlng);
        closeContext();
    }

    const showContextMenu = (context && context.visible) ? true : false;
    const menuPos = showContextMenu ?
        {
            left: context.menuPosition.left,
            top: context.menuPosition.top
        }
        : { left: 0, top: 0 };


    function getMapIcon(mode, time) {
        const iconUrl = './img/modes/' + mode + ".svg";

        const divContent3 = <div
            style={{ backgroundColor: "white", borderRadius: 5, paddingTop: 6, paddingLeft: 13, width: 50, height: 50 }}>
            <img style={{width:"20px", height:"20px"}} src={iconUrl} /><br />
            {Helpers.secondsToTime(time)}
        </div>;

        return L.divIcon({
            className: '',
            iconSize: [50, 50],
            html: ReactDOMServer.renderToStaticMarkup(divContent3),
            iconAnchor: [55, 55],

        });
    }

    function getStopIcon() {
        const step = itineraries.plan.itineraries.find(findIti).legs[selectedLegIndex].steps[selectedStepIndex];
        const distanceJed = step.distance < 1000 ? "m" : "km";
        const distance = step.distance < 1000 ? Helpers.roundTo0Decimal(step.distance) : Helpers.roundTo1Decimal(step.distance / 1000);

        const divContent = <div
            style={{
                backgroundColor: "white",
                borderRadius: 5,
                paddingTop: 6,
                paddingBottom: 6,
                paddingLeft: 10,
                border: "1px solid black"
            }}>
            {step.relativeDirection} to {step.streetName}, {distance} {distanceJed}
        </div>

        return L.divIcon({
            className: '',
            iconSize: [250, 100],
            html: ReactDOMServer.renderToStaticMarkup(divContent),
            iconAnchor: [255, 0],

        });
    }

    function getBusStopIcon(where) {
        
        // const leg = itineraries.plan.itineraries.find(selectedItineraryId).legs[selectedLegIndex];

        // const divContent = <div
        //     style={{
        //         backgroundColor: "white",
        //         borderRadius: 5,
        //         paddingTop: 6,
        //         paddingBottom: 6,
        //         paddingLeft: 10,
        //         border: "1px solid black"
        //     }}>
        //     {Helpers.secondsToTime(leg[where].departure)} {leg[where].name}
        // </div>;

        const divContent = <div>N/A</div>

        return L.divIcon({
            className: '',
            iconSize: [250, 100],
            html: ReactDOMServer.renderToStaticMarkup(divContent),
            iconAnchor: [255, 0],

        });
    }

    function getElectricStationIcon(leg) {
        const divContent = <div
            style={{
                backgroundColor: "white",
                borderRadius: 5,
                paddingTop: 6,
                paddingBottom: 6,
                paddingLeft: 10,
                border: "1px solid black"
            }}>
            <div>{leg.agencyName}</div>
            <div>{leg.agencyUrl}</div>
            <div>Charge time {Helpers.secToMin(leg.duration)}</div>
            <div>Charging from {leg.startChargeLevel} % to {leg.endChargeLevel} %</div>
            <div>Charging cost {Helpers.grToPln(leg.chargingStationFare.fare.regular.cents)} {leg.chargingStationFare.fare.regular.currency.symbol}</div>

        </div>

        return L.divIcon({
            className: '',
            iconSize: [250, 100],
            html: ReactDOMServer.renderToStaticMarkup(divContent),
            iconAnchor: [255, 0],

        });
    }

    function getChargingStations() {
        let polilynes = [];
        if(state.stations){
            state.stations.forEach(station => {
                polilynes.push(<Marker
                    icon={electricChargerIconSmall}
                    draggable={false}
                    position={[station.lat, station.lon]}>
                </Marker>);
            });
        }
        return polilynes;
    }

    // draw road support
    function getPoli() {
        Logger.log("map get")
        if (selectedItineraryId === undefined) {
            return ""
        }
        let polilynePos = [];
        let polilynes = [];
        const colors = ["black", "blue"];
        let colorIn = 0;

        function chooseLineColor(mode) {
            Logger.log("choosing line color for " + mode);
            if (state.colors[mode]) {
                return state.colors[mode];
            }
            colorIn = (colorIn + 1) % colors.length;
            return colors[colorIn];
        }

        if (itineraries) {
            itineraries.plan.itineraries.find(findIti).legs.forEach((leg, legIndex) => {
                polilynePos = decodePolyline(leg.legGeometry.points);
                const isHighlighted = state.highlightLeg !== undefined && selectedItineraryId === state.highlightLeg.iti &&
                    state.highlightLeg.leg === legIndex;
                const isSelected = state.selectedLegIndex === legIndex;

                polilynes.push(<Polyline key={legIndex} weight={isSelected || isHighlighted ? 8 : 3}
                    color={chooseLineColor(leg.mode)}
                    positions={polilynePos} />);

                // handle electic station on a map
                if (leg.mode === "STATION") {
                    const l = itineraries.plan.itineraries.find(findIti).legs[legIndex];
                    const c = {
                        lat: l.from.lat,
                        lng: l.from.lon,
                    };

                    polilynes.push(<Marker
                        icon={electricChargerIconSmall}
                        draggable={false}
                        position={c}>
                    </Marker>);
                }
                // if leg is selected (clicked on )draw draw leg markers and stop maker (if also selected)
                if (isSelected) {
                    Logger.log("selected leg mode is " + leg.mode)
                    Logger.log("selected leg index  " + selectedLegIndex)
                    if (state.selectedStepIndex !== undefined) {
                        // for bus we have to show first and second stop only
                        if (leg.mode === "BUS") {
                            const l = itineraries.plan.itineraries.find(findIti).legs[selectedLegIndex];
                            const c = {
                                lat: l[state.selectedStepIndex].lat,
                                lng: l[state.selectedStepIndex].lon,
                            };
                            const icon = getBusStopIcon(l);

                            polilynes.push(<Marker
                                icon={icon}
                                draggable={false}
                                position={c}>
                            </Marker>);
                            polilynes.push(<Marker
                                icon={circleIcon}
                                draggable={false}
                                position={c}>
                            </Marker>);
                        } else {
                            // handle all steps except bus
                            const center = {
                                lat: itineraries.plan.itineraries.find(findIti).legs[selectedLegIndex].steps[selectedStepIndex].lat,
                                lng: itineraries.plan.itineraries.find(findIti).legs[selectedLegIndex].steps[selectedStepIndex].lon,
                            };
                            polilynes.push(<Marker
                                icon={getStopIcon()}
                                draggable={false}
                                position={center}>
                            </Marker>);
                            polilynes.push(<Marker
                                icon={circleIcon}
                                draggable={false}
                                position={center}>
                            </Marker>);
                        }
                    }

                    // for electric charging statni we only draw one element on map when is hightlighted
                    if (leg.mode === "STATION") {
                        polilynes.push(<Marker
                            icon={getElectricStationIcon(leg)}
                            draggable={true}
                            descr={"End"}
                            position={[leg.from.lat, leg.from.lon]}
                           />);

                    } else {
                        // add start and end markers in case of selected leg
                        polilynes.push(<Marker
                            icon={getMapIcon(leg.mode, leg.startTime)}
                            draggable={false}
                            descr={"End"}
                            position={[leg.from.lat, leg.from.lon]}>
                            <Popup>
                                End
                            </Popup>
                        </Marker>);
                        polilynes.push(<Marker
                            icon={getMapIcon(leg.mode, leg.endTime)}
                            draggable={false}
                            descr={"End"}
                            position={[leg.to.lat, leg.to.lon]}
                           >
                            <Popup>
                                End
                            </Popup>
                        </Marker>);
                    }
                }
            }
            );

        }
        return polilynes;
    }

    function getBound(legs) {
        let minLat, maxLat, minLng, maxLng;

        legs.forEach(leg => {
            const polilynePos = decodePolyline(leg.legGeometry.points);
            polilynePos.forEach(point => {
                const lat = point[0];
                const lng = point[1];
                if (!minLat) { // initial bounds
                    minLat = maxLat = lat;
                    minLng = maxLng = lng;
                } else {
                    if (minLat > lat)
                        minLat = lat;
                    if (maxLat < lat)
                        maxLat = lat;
                    if (minLng > lng)
                        minLng = lng;
                    if (maxLng < lng)
                        maxLng = lng;
                }
            })
        });

        return [{ lat: maxLat, lng: maxLng }, { lat: minLat, lng: minLng }]
    }

    function calculateBounds() {
        let bounds, center, zoom = null;

        if (itineraries === undefined || selectedItineraryId === undefined) {
            if (state.startPosition && state.endPosition) {
                bounds = Helpers.calculateBounds(state.startPosition, state.endPosition)
            } else {
                // focus on default focus point
                zoom = Helpers.defaultMapZoom;
                if (state.startPosition) {
                    center = state.startPosition;
                } else if (state.endPosition) {
                    center = state.endPosition
                } else
                    center = state.mapDefaultCenter ? state.mapDefaultCenter : Helpers.defaultMapCenter;
            }
        } else {
            if (selectedItineraryId !== undefined) {
                if (selectedLegIndex !== undefined) {
                    if (selectedStepIndex !== undefined) {
                        if (itineraries.plan.itineraries.find(findIti).legs[selectedLegIndex].mode === "BUS") {
                            center = {
                                lat: itineraries.plan.itineraries.find(findIti).legs[selectedLegIndex][selectedStepIndex].lat,
                                lng: itineraries.plan.itineraries.find(findIti).legs[selectedLegIndex][selectedStepIndex].lon,
                            }
                        } else {
                            center = {
                                lat: itineraries.plan.itineraries.find(findIti).legs[selectedLegIndex].steps[selectedStepIndex].lat,
                                lng: itineraries.plan.itineraries.find(findIti).legs[selectedLegIndex].steps[selectedStepIndex].lon,
                            };
                        }
                        zoom = Helpers.defaultMapZoomOnSelectPoint;
                    } else {
                        // In case of mouse over charging station
                        if (itineraries.plan.itineraries.find(findIti).legs[selectedLegIndex].mode === "STATION") {
                            center = {
                                lat: itineraries.plan.itineraries.find(findIti).legs[selectedLegIndex].from.lat,
                                lng: itineraries.plan.itineraries.find(findIti).legs[selectedLegIndex].from.lon,
                            }
                            zoom = Helpers.defaultMapZoomOnSelectPoint;
                        } else                         // In case of mouse over other charging station

                            bounds = getBound([itineraries.plan.itineraries.find(findIti).legs[selectedLegIndex]]);
                    }
                } else {
                    bounds = getBound(itineraries.plan.itineraries.find(findIti).legs);
                }
            }
        }
        Logger.log("Bounds");
        Logger.log(bounds);

        return { center, bounds, zoom }
    }

    let { center, bounds, zoom } = calculateBounds();

    return (
        <LeafletMap
            bounds={bounds}
            center={center}
            zoom={zoom}
            maxZoom={19}
            attributionControl={true}
            zoomControl={true}
            doubleClickZoom={false}
            scrollWheelZoom={true}
            dragging={true}
            animate={true}
            easeLinearity={0.35}
            onClick={handleLeftClick}
            onContextmenu={handleContextMenuClick}
        >
            <TileLayer
                attribution='<a href="http://osm.org/copyright">OpenStreetMap</a>'
                url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
            />
            {getFrom()}
            {getTo()}
            {getPoli()}
            {getChargingStations()}
            <Menu open={showContextMenu}
                anchorReference={"anchorPosition"}
                anchorPosition={menuPos}
                onClose={closeContext}
            >
                <MenuItem onClick={setStartContext}>{t("Set start")}</MenuItem>
                <MenuItem onClick={setEndContext}>{t("Set end")}</MenuItem>
            </Menu>
        </LeafletMap>
    );


}

export default Map
